const CartGenius = function () {
    // session storage key
    const _CART_GENIUS_PRODUCTS_LIST = 'cartGeniusProductsList';
    const _CART_GENIUS_USER_REMOVED_SKUS_LIST = 'cartGeniusUserRemovedSKUs';
    const _CART_GENIUS_PRODUCTS_TOTAL_PRICE = 'cartGeniusProductsTotalPrice';
    // origin
    const _CART_GENIUS_ORIGIN = "CART_GENIUS";

    const cartGeniusContainerClass = '.cart-genius-side-panel-container';
    const cartGeniusSidePanelSelector = cartGeniusContainerClass + ' .cart-genius-side-panel';
    const cartGeniusContentContainer = cartGeniusContainerClass + ' .cart-genius-content-container';
    const cartGeniusFullSelector = cartGeniusContainerClass + ' .cart-genius-full';
    const cartGeniusHeaderSelector = cartGeniusContainerClass + ' .cart-genius-header';
    const cartGeniusFooterSelector = cartGeniusContainerClass + ' .cart-genius-side-panel--pricing';
    const $body = $('body');


    //****************************************************************
    // Ajax
    //****************************************************************
    const _getCartGenius = function () {
        // Make sure that cartGeniusSidePanelURL is defined
        if (!cartGeniusSidePanelURL) {
            return;
        }

        TINK.inProgress($body);

        // create CART_GENIUS_PRODUCTS_LIST in session
        if (!sessionStorage.getItem(CartGenius.CART_GENIUS_PRODUCTS_LIST)) {
            sessionStorage.setItem(CartGenius.CART_GENIUS_PRODUCTS_LIST, JSON.stringify([]));
        }

        if (!sessionStorage.getItem(CartGenius.CART_GENIUS_USER_REMOVED_SKUS_LIST)) {
            sessionStorage.setItem(CartGenius.CART_GENIUS_USER_REMOVED_SKUS_LIST, JSON.stringify([]));
        }

        let cartGeniusViewDetailsURL = new URL(cartGeniusSidePanelURL, window.location.origin);

        // Add skus removed from the user
        if (sessionStorage.getItem(_CART_GENIUS_USER_REMOVED_SKUS_LIST) && sessionStorage.getItem(_CART_GENIUS_USER_REMOVED_SKUS_LIST).length > 0) {
            let productsFromSession = JSON.parse(sessionStorage.getItem(_CART_GENIUS_USER_REMOVED_SKUS_LIST));
            let cartGeniusProductsToRemove = productsFromSession || [];

            cartGeniusViewDetailsURL.searchParams.set('skusToRemove', cartGeniusProductsToRemove.join(','));
        }

        if (sessionStorage.getItem('forceCartGeniusCacheInvalidation')) {
            let forceCartGeniusCacheInvalidation = sessionStorage.getItem('forceCartGeniusCacheInvalidation');

            cartGeniusViewDetailsURL.searchParams.set('forceCartGeniusCacheInvalidation', forceCartGeniusCacheInvalidation);
            sessionStorage.removeItem('forceCartGeniusCacheInvalidation');

            if (!$('#cartGeniusContent').length) {
                sessionStorage.removeItem('triggerOpeningCartGeniusAfterReload');
            }
        }

        $.ajax({
            url: cartGeniusViewDetailsURL.toString(),
            type: 'GET',
            headers: {
                'Accept-Language': lang
            },
            dataType: 'html',
            cache: false,
            success: function (data) {

                _triggerCartGeniusModal();
                _toggleEmptyCartGenius(false);
                $('.cart-genius-side-panel--products-list').html(data);
                _updateCartGeniusHeader();
                _updateCartGeniusList();
                _updateCartGeniusFooter();
                _checkIfMinSelected();

                const hasError = $(data).find('.cartGeniusAlertInfoClose.cta-secondary').length > 0;
                if (hasError) {
                    _push_custom_event_to_GA4('error_message', 'error_description', 'cart genius | unable to load products');
                }
            },
            error: function (jqXHR) {
                TINK.redirectIfConflict(jqXHR);
            },
            complete: function () {
                setTimeout(function () {
                    TINK.stopProgress($body);
                }, 350);

            }
        });
    };

    function _incrementClickEvent(event) {
        var product = $(event.target).closest('.item-addToCart');
        var unitIncrement = +(product.data('unit-increment'));
        var minQty = +(product.data('min-qty'));
        var maxQty = +(product.data('max-qty'));
        var plusTriggered = $(event.target).is('.plus-addToCart-from-cartgenius');
        var currentValue = +(product.find('.qty-addToCart').first().text());
        var deletable = product.data('product-deletable');
        var minAllowed = deletable ? minQty - unitIncrement : minQty;

        var newValue;
        var productStarter = false;
        if (plusTriggered) {
            if (currentValue == 0) {
                newValue = minQty;
                productStarter = true;
            } else {
                newValue = currentValue + unitIncrement;
            }

            if (newValue <= maxQty) {
                product.find('.qty-addToCart').text(newValue);
                updateQuantityButtonsState(product, productStarter);
            }
        } else {
            newValue = currentValue - unitIncrement;
            if (newValue >= minAllowed) {
                product.find('.qty-addToCart').text(newValue);
                updateQuantityButtonsState(product, productStarter);
            }
        }
    }

    const _updateCartGeniusProduct = function (event) {
        // Override _incrementClickEvent in qty-incrementer.js because the current listener updates the quantity on all product tiles that share the same SKU
        _incrementClickEvent(event);

        let $productTile = $(this).closest('.default-product-tile');
        let qty = $productTile.find('.qty-addToCart').text();
        let productSKU = $productTile.attr('data-product-code');
        let minQty = $productTile.attr('data-min-qty');
        let maxQty = $productTile.attr('data-max-qty');

        // the qty should always be >= to minQty
        qty = (parseFloat(minQty) > parseFloat(qty)) ? "0" : qty;
        $productTile.attr('data-genius-qty', qty);

        if (qty === maxQty) {
            $productTile.find('.plus-addToCart-from-cartgenius').prop('disabled', true);
        } else {
            $productTile.find('.plus-addToCart-from-cartgenius').prop('disabled', false);
        }

        // update CART_GENIUS_PRODUCTS_LIST
        _saveUpdatedProductInSession($productTile, productSKU, qty);

        _calculateCartGeniusTotalPrice();
    };

    const _saveUpdatedProductInSession = function ($productTile, productSKU, qty) {
        // update CART_GENIUS_PRODUCTS_LIST
        if (sessionStorage.getItem(_CART_GENIUS_PRODUCTS_LIST) && productSKU) {
            let productsFromSession = JSON.parse(sessionStorage.getItem(_CART_GENIUS_PRODUCTS_LIST));
            let product = productsFromSession.find(item => item.sku === productSKU);

            if (product) {
                // update the product qty
                product.qty = qty;
                // get the product option id
                if ($productTile.find('.select-addToCart').length) {
                    let $selectedOption = $('option:selected', $productTile);
                    product.optionId = $selectedOption.attr('code-id');
                }

            } else {
                // push the product to the session storage
                product = _createNewProductInSession($productTile, qty);

                productsFromSession.push(product);
            }

            sessionStorage.setItem(_CART_GENIUS_PRODUCTS_LIST, JSON.stringify(productsFromSession));

            // show the stored qty
            $productTile.find('.qty-addToCart').text(qty);

            if (parseFloat(qty) === 0) {
                $productTile.find('.minus-addToCart-from-cartgenius').prop('disabled', true);
            } else {
                $productTile.find('.minus-addToCart-from-cartgenius').prop('disabled', false);
            }
        }
    }

    const _createNewProductInSession = function ($productTile, qty) {
        let productName = $productTile.attr('data-product-name'),
            sku = $productTile.attr('data-product-code'),
            shopTrackingToken = $productTile.attr('data-shop-tracking-token'),
            shopTrackingWebPage = $productTile.attr('data-shop-tracking-web-page'),
            selector = $productTile.find('.select-addToCart'),
            optionId = $productTile.attr('data-code-id'),
            optionCode = selector.attr('data-configuration-code'),
            productAlcohol = $productTile.attr('data-product-alcohol'),
            productLoto = $productTile.attr('data-product-loto');

        // get the product option id
        if ($productTile.find('.select-addToCart').length) {
            let $selectedOption = $('option:selected', $productTile);
            optionId = $selectedOption.attr('code-id');
        }

        return new Product(sku, qty, optionId, optionCode, productName, shopTrackingToken, shopTrackingWebPage, productAlcohol, productLoto);
    }

    const _calculateCartGeniusTotalPrice = function () {
        // calculer total
        let total = 0.0;
        let $banniereGeniusTotal = $('#cartGeniusContent .cartGenius--items .genius_grid_info .total-cart-genius');

        $('.cart-genius-side-panel--products-list .default-product-tile').each(function () {
            let $tile = $(this).closest('.default-product-tile');
            let qte = $tile.attr('data-genius-qty') / $tile.attr('data-unit-increment');
            let $selectedOption = $('option:selected', this);
            let tilePrice;
            if ($tile.find('.select-addToCart').length && $selectedOption.length && $selectedOption.attr('main-price')) {
                tilePrice = parseFloat($selectedOption.attr('main-price').replace("$", ""));
            } else {
                tilePrice = parseFloat($tile.find('div[data-main-price]').data('main-price'));
            }

            total += qte * tilePrice;
        });

        let $cartGeniusFooter = $(cartGeniusFooterSelector);
        let formattedPrice = total.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        if (lang === 'fr') {
            formattedPrice = formattedPrice.replace('.', ',');
            $cartGeniusFooter.find('.subtotal').text(formattedPrice + ' $');
            $banniereGeniusTotal.text('Total ' + formattedPrice + ' $');
            sessionStorage.setItem(_CART_GENIUS_PRODUCTS_TOTAL_PRICE, 'Total ' + formattedPrice + ' $');
        } else {
            $cartGeniusFooter.find('.subtotal').text('$' + formattedPrice);
            $banniereGeniusTotal.text('Total ' + '$' + formattedPrice);
            sessionStorage.setItem(_CART_GENIUS_PRODUCTS_TOTAL_PRICE, 'Total ' + '$' + formattedPrice);
        }
    }

    const _checkIfMinSelected = function () {
        let nbTotal = 0;
        $('.cart-genius-side-panel--products-list .default-product-tile').each(function () {
            let qte = (parseInt($(this).attr('data-genius-qty'), 10) >= parseInt($(this).attr('data-min-qty'), 10)) ? parseInt($(this).attr('genius-qty'), 10) : parseInt(0, 10);
            nbTotal += qte;
        });

        if (nbTotal === 0) {
            $('#cart-genius-add-button-items').prop('disabled', true);
        } else {
            $('#cart-genius-add-button-items').prop('disabled', false);
        }
    }

    const _deleteCartGeniusItem = function () {
        // send item to 0
    };

    //****************************************************************
    // Update dom
    //****************************************************************

    const _updateCartGeniusHeader = function () {
        let $cartGeniusHeader = $(cartGeniusHeaderSelector);
        let count = $('.cart-genius-side-panel--products-list .default-product-tile').length;

        $cartGeniusHeader.find('.cartGeniusNbItems').text(count);
        count > 1 ? $cartGeniusHeader.find('.cartGeniusNbItemsText').addClass('plural') : $cartGeniusHeader.find('.cartGeniusNbItemsText').removeClass('plural');


        if (isRegistered && !isAccountWithOrders) {
            $('.cart-genius-header-text .anonymous').addClass('hide');
            $('.cart-genius-header-text .hasNotUsedGenius').removeClass('hide');
        } else if (isRegistered && isAccountWithOrders) {
            $('.cart-genius-header-text .anonymous').addClass('hide');
            $('.cart-genius-header-text .hasUsedGenius').removeClass('hide');
        }


    };

    const _updateCartGeniusList = function () {
        // Change the class names plus-addToCart and minus-addToCart to avoid the default qty incrementer listener that updates the quantity for all products with the same SKU
        $('.cart-genius-side-panel--products-list .default-product-tile .plus-addToCart')
            .removeClass('plus-addToCart')
            .addClass('plus-addToCart-from-cartgenius');

        $('.cart-genius-side-panel--products-list .default-product-tile .minus-addToCart')
            .removeClass('minus-addToCart')
            .addClass('minus-addToCart-from-cartgenius');

        $('.cart-genius-side-panel--products-list .default-product-tile .plus-updateCart').removeClass('plus-updateCart');
        $('.cart-genius-side-panel--products-list .default-product-tile .plus-addToCart-from-cartgenius').addClass('isGenius');
        $('.cart-genius-side-panel--products-list .default-product-tile .pt__content--actions').addClass('in-cart');
        $('.cart-genius-side-panel--products-list .default-product-tile .btn--minus').addClass('multiple-in-cart');
        $('.cart-genius-side-panel--products-list .default-product-tile .btn--minus').addClass('isGenius');
        $('.cart-genius-side-panel--products-list .default-product-tile .btn--minus').removeClass('minus-updateCart');

        $('#cart-genius-add-button').show();

        $('.cart-genius-side-panel--products-list .default-product-tile').each(function () {
            let $tile = $(this).closest('.default-product-tile');
            let qty = $tile.find('.qty-addToCart').text();
            let productSKU = $tile.attr('data-product-code');
            let notEligible = Boolean(qty === '0' && $tile.find('.plus-addToCart-from-cartgenius').prop('disabled'));

            // get CART_GENIUS_PRODUCTS_LIST from session
            if (sessionStorage.getItem(_CART_GENIUS_PRODUCTS_LIST) && productSKU) {
                let productsFromSession = JSON.parse(sessionStorage.getItem(_CART_GENIUS_PRODUCTS_LIST));
                let product = productsFromSession.find(item => item.sku === productSKU);
                qty = (product && parseFloat(product.qty) >= 0) ? product.qty : qty;
                // get the product option id
                if (product && $tile.find('.select-addToCart').length) {
                    let optionId = product.optionId;
                    let $option = $tile.find('option[code-id="' + optionId + '"]');
                    if ($option.length) {
                        $option.prop('selected', true);
                    }
                }
            }

            $tile.attr('data-genius-qty', qty);
            $tile.find('.qty-addToCart').text(qty);

            if (parseFloat(qty) === 0) {
                $tile.find('.minus-addToCart-from-cartgenius').prop('disabled', true);
            } else {
                $tile.find('.minus-addToCart-from-cartgenius').prop('disabled', false);
            }

            if (notEligible) {
                // Save not eligible product in session storage (alcohol product that cannot be added to cart)
                // as if the user has refused the product explicitly
                _saveUpdatedProductInSession($tile, productSKU, '0');
            }
        });
    };

    const _updateTileSelection = function (event) {
        let $Selection = $(event.target);
        let $tile = $Selection.closest('.cart-genius-side-panel--products-list .default-product-tile');
        let qty = $tile.find('.qty-addToCart').text();
        let productSKU = $tile.attr('data-product-code');

        // get CART_GENIUS_PRODUCTS_LIST from session
        if (sessionStorage.getItem(_CART_GENIUS_PRODUCTS_LIST) && productSKU) {
            let productsFromSession = JSON.parse(sessionStorage.getItem(_CART_GENIUS_PRODUCTS_LIST));
            let product = productsFromSession.find(item => item.sku === productSKU);
            qty = (product && parseFloat(product.qty) >= 0) ? product.qty : qty;

            if (!product) {
                product = _createNewProductInSession($tile, qty);
                productsFromSession.push(product);
            }
            // get the product option id
            let $selectedOption = $('option:selected', $Selection);
            product.optionId = $selectedOption.attr('code-id');

            sessionStorage.setItem(_CART_GENIUS_PRODUCTS_LIST, JSON.stringify(productsFromSession));
        }

        // update the qty
        $tile.attr('data-genius-qty', qty);
        $tile.find('.qty-addToCart').text(qty);

        // show the minus and add plus addToCart
        $tile.find('.plus-updateCart').removeClass('plus-updateCart');
        $tile.find('.plus-addToCart-from-cartgenius').addClass('isGenius');
        $tile.find('.pt__content--actions').addClass('in-cart');
        $tile.find('.btn--minus').addClass('multiple-in-cart');
        $tile.find('.btn--minus').addClass('isGenius');
        $tile.find('.btn--minus').removeClass('minus-updateCart');

        if (parseFloat(qty) === 0) {
            $tile.find('.minus-addToCart-from-cartgenius').prop('disabled', true);
        } else {
            $tile.find('.minus-addToCart-from-cartgenius').prop('disabled', false);
        }

        _calculateCartGeniusTotalPrice();
    };

    const _updateCartGeniusFooter = function () {
        let $cartGeniusFooter = $(cartGeniusFooterSelector);

        if (typeof timeslotDateFormattedValue !== "undefined") {
            $cartGeniusFooter.find('.validDate').text(timeslotDateFormattedValue);
        }

        _calculateCartGeniusTotalPrice();
    };

    const _toggleEmptyCartGenius = function (empty) {
        let $cartGeniusFooter = $(cartGeniusFooterSelector);

        $(cartGeniusFullSelector).removeClass('hide');
        $cartGeniusFooter.removeClass('hide');

        if (empty) {
            $('#cart-genius-add-button').removeClass('hide');
            $('#cart-genius-add-button-items').addClass('hide');
            $('#cart-genius-add-button').trigger('click');
        } else {
            $('#cart-genius-add-button').addClass('hide');
            $('#cart-genius-add-button-items').removeClass('hide');
        }
    };


    //****************************************************************
    // Misc
    //****************************************************************

    let lastScrollTop = 60;
    $(cartGeniusContentContainer).on('scroll', function () {
        const offset = this.pageYOffset || this.scrollTop;
        const hideHeader = offset > lastScrollTop;
        _toggleHeaderVisibility(!hideHeader);
    });

    const _triggerCartGeniusModal = function () {
        if (!$(cartGeniusSidePanelSelector).hasClass('remodal-is-opened')) {
            $('#cartGeniusModal').remodal().open();
            TINK.updateStatusNotification(window['cartGeniusOpenMessage']);
            TINK.trapFocus($('#cartGeniusModal.cart-genius-side-panel'), _closeModal());
        }

        //Make sure the Cart Genius side-panel container is visible
        $(cartGeniusContentContainer).removeClass('hide');
        $(cartGeniusFooterSelector).removeClass('hide');
    };

    const _closeModal = function () {
        if ($(cartGeniusSidePanelSelector).hasClass('remodal-is-opened')) {
            if (isInWebview()) {
                sendCloseWebviewEventToDeviceCloseOnly();
            }
            $('#cartGeniusModal').remodal().close();
            _cleanUpOnModalClose();
        }
    };

    const _toggleHeaderVisibility = function (visible) {
        if (visible) {
            $(cartGeniusSidePanelSelector + ' .modal__close').removeClass('cart--btn--scrolled');
        } else {
            $(cartGeniusSidePanelSelector + ' .modal__close').addClass('cart--btn--scrolled');
        }
    };

    const _cleanUpOnModalClose = function () {
        $body.css('padding-right', '0'); // fix remodal and dishide conflict
    };

    const _manageMiniCartFocus = function () {
        $(cartGeniusHeaderSelector + ' h2').focus();
    };

    // Cart genius Bind add to cart
    const _bindAddCartGeniusProductsToCart = function () {
        $('#cart-genius-add-button-items').on('click', function (e) {
            $(this).attr('disabled', true);
            _push_custom_event_to_GA4('cart_genius_click', 'description', 'panel | add all to my cart');
            addCartGeniusProductsToCart($(this), $('.cart-genius-full'), $('#cartGeniusModal'));
            window.localStorage.setItem("hasUsedGenius", "true");
            sessionStorage.removeItem(_CART_GENIUS_PRODUCTS_TOTAL_PRICE);
        });
    };

    function addCartGeniusProductsToCart($target, $tilesContainer, $waitingContainer) {
        var productsListToAdd = [];
        var productsTilesList = [];

        TINK.inProgress($waitingContainer);

        // Get all selected products to add to cart (not in cart)
        var isProductSelectionError = false;
        $('.cartGeniusSidePanelProducts .tile-product', $tilesContainer).each(function () {
            var productTile = $(this);
            var inCart = productTile.hasClass('item-in-cart');
            var qty = productTile.attr('data-genius-qty') || 1;

            if (!inCart.length && qty > 0) {
                var productName = productTile.attr('data-product-name'),
                    sku = productTile.attr('data-product-code'),
                    shopTrackingToken = productTile.attr('data-shop-tracking-token'),
                    shopTrackingWebPage = productTile.attr('data-shop-tracking-web-page'),
                    selector = productTile.find('.select-addToCart'),
                    optionSelected = $('option:selected', selector),
                    optionVal = optionSelected.val(),
                    optionId = optionSelected.attr('code-id'),
                    optionCode = selector.attr('data-configuration-code'),
                    ageRestricted = productTile.data('age-restriction'),
                    productAlcohol = productTile.data('product-alcohol'),
                    productLoto = productTile.data('product-loto');

                if (optionSelected.length && (!optionVal || optionVal == '-1' || optionVal == '1')) {
                    productTile.addClass('error');
                    hideErrorMessages(productTile);
                    productTile.find('.error-summary').removeClass('hide').attr('tabindex', '0').focus();
                    productTile.find('.product-make-choice-error').removeClass('hide');
                    isProductSelectionError = true;
                } else if ((ageRestricted && $('.mini-cart-side-panel--spontaneous').attr('data-express-service') === 'true') ||
                    (productAlcohol && $('.mini-cart-side-panel--spontaneous').attr('data-alcohol-data-alcohol-delivery-disallowed-by-store') === 'true') ||
                    (productAlcohol && $('.mini-cart-side-panel--spontaneous').attr('data-alcohol-data-alcohol-delivery-disallowed-by-timeslot') === 'true') ||
                    (productAlcohol && $('.mini-cart-side-panel--spontaneous').attr('data-cart-fsa-alcohol-restricted') === 'true')) {
                    productTile.addClass('error');
                    hideErrorMessages(productTile);
                    productTile.find('.error-summary').removeClass('hide').attr('tabindex', '0').focus();
                    productTile.find('.product-age-restriction-cart-starter-error').removeClass('hide');
                    isProductSelectionError = true;
                } else {
                    var product = new Product(sku, qty, optionId, optionCode, productName, shopTrackingToken, shopTrackingWebPage, productAlcohol, productLoto, 'cartGenius');
                    productsListToAdd.push(product);
                    productsTilesList.push(productTile);
                }
                push_add_cart_info_metrics(productTile, qty, "cartGenius");
            }
        });

        if (!isProductSelectionError) {
            if (productsListToAdd.length < 1) {
                window['displayCartNotification'](0, $waitingContainer, null);
            } else {
                var $errorBox = $('#errorBoxCartStarter');
                if ($errorBox.length < 1) {
                    $errorBox = $('#errorBox');
                }

                let callbackFunctionWithOrigin = createCallbackFunctionWithOrigin(_addProductsCallback, $waitingContainer);
                let errorCallbackFunctionWithOrigin = createCallbackFunctionWithOrigin(_addProductsErrorCallback, $waitingContainer);
                addSelectedProductsToCart(productsListToAdd, productsTilesList, callbackFunctionWithOrigin, errorCallbackFunctionWithOrigin, $target, undefined, $errorBox, true, null);

                // In webview, if the user has no store after starting the add-products flow, ensure isCartGeniusOpened is set to true so the timeslots side panel reopens
                if (isInWebview() && !window['storeId']) {
                    window['isCartGeniusOpened'] = true;
                }

                // Add products with 0 qty to CART_GENIUS_USER_REMOVED_SKUS_LIST
                if (sessionStorage.getItem(CartGenius.CART_GENIUS_PRODUCTS_LIST) && sessionStorage.getItem(CartGenius.CART_GENIUS_PRODUCTS_LIST).length > 0) {
                    let productsFromSession = JSON.parse(sessionStorage.getItem(CartGenius.CART_GENIUS_PRODUCTS_LIST));
                    let cartGeniusProductsToRemove = productsFromSession.filter(item => item.qty === "0").map(item => item.sku) || [];
                    sessionStorage.setItem(CartGenius.CART_GENIUS_USER_REMOVED_SKUS_LIST, JSON.stringify(cartGeniusProductsToRemove));
                }
            }
        } else {
            TINK.stopProgress($waitingContainer);
        }
    }

    function _addProductsCallback($waitingContainer) {
        if ($waitingContainer) {
            TINK.stopProgress($waitingContainer);
        }
        _closeModal();

        CartGeniusBanner.asyncLoadCartGeniusCallback();
    }

    function _addProductsErrorCallback($waitingContainer) {
        if ($waitingContainer) {
            TINK.stopProgress($waitingContainer);
        }
        _closeModal();

        CartGeniusBanner.asyncLoadCartGeniusCallback($('#cart-genius-main'), true);
    }

    function createCallbackFunctionWithOrigin(callback, $waitingContainer) {
        let wrappedCallback = function () {
            callback($waitingContainer);
        };
        wrappedCallback.origin = _CART_GENIUS_ORIGIN;
        wrappedCallback.waitingContainer = $waitingContainer;
        return wrappedCallback;
    }

    function _sendAddProductEvent(products, numberOfItems) {
        if (!isInWebview()) {
            return;
        }

        for (let i = 0; i < products.length; i++) {
            let product = products[i];
            sendCartItemUpdateEventToDevice(product);
        }

        sendNewQtyInCartEventToDevice(numberOfItems);
    }

    //****************************************************************
    // Expose for binding
    //****************************************************************

    return {
        CART_GENIUS_PRODUCTS_LIST: _CART_GENIUS_PRODUCTS_LIST,
        CART_GENIUS_USER_REMOVED_SKUS_LIST: _CART_GENIUS_USER_REMOVED_SKUS_LIST,
        CART_GENIUS_PRODUCTS_TOTAL_PRICE: _CART_GENIUS_PRODUCTS_TOTAL_PRICE,
        CART_GENIUS_ORIGIN: _CART_GENIUS_ORIGIN,
        getCartGenius: _getCartGenius,
        updateCartGeniusProduct: _updateCartGeniusProduct,
        deleteCartGeniusItem: _deleteCartGeniusItem,
        cleanUpOnModalClose: _cleanUpOnModalClose,
        manageMiniCartFocus: _manageMiniCartFocus,
        triggerCartGeniusModal: _triggerCartGeniusModal,
        toggleEmptyCartGenius: _toggleEmptyCartGenius,
        closeModal: _closeModal,
        bindAddCartGeniusProductsToCart: _bindAddCartGeniusProductsToCart,
        sendAddProductEvent: _sendAddProductEvent,
        checkIfMinSelected: _checkIfMinSelected,
        updateTileSelection: _updateTileSelection,
    };
}();


//****************************************************************
// Binding
//****************************************************************
$(document).ready(function () {
    CartGenius.bindAddCartGeniusProductsToCart();
});

// waiting 10ms to override std addToCart values
$(document).on('click', '.cart-genius-side-panel--products-list button.plus-addToCart-from-cartgenius, .cart-genius-side-panel--products-list button.minus-addToCart-from-cartgenius', debounce(CartGenius.updateCartGeniusProduct, 10));
$(document).on('click', '.cart-genius-side-panel--products-list button.plus-addToCart-from-cartgenius, .cart-genius-side-panel--products-list button.minus-addToCart-from-cartgenius', debounce(CartGenius.checkIfMinSelected, 20));

$(document).on('change', '.cart-genius-side-panel--products-list .select-addToCart', debounce(CartGenius.updateTileSelection, 10));
$(document).on('click', '.cart-genius-side-panel--products-list button.lastInCart', debounce(CartGenius.deleteCartGeniusItem, 250));

$(document).on('click', '.cart-genius-full.cart-genius-sub-modal-container .close-sub', function () {
    $('.cart-genius-full .cart-genius-sub-modal-container').css({"display": "none"});
});

$(document).on('click', '.cartGeniusAlertInfoClose', function () {
    $('.modal__close.focusable').trigger('click');
    if (isInWebview()) {
        sendCloseWebviewEventToDevice('continueShopping');
    }
    _push_custom_event_to_GA4('cart_genius_click', 'description', 'panel | error - try again button');
});

$(document).on('click', '.cart-genius-content-container .modal__close', function (e) {
    if (e.originalEvent === undefined) return;
    _push_custom_event_to_GA4('cart_genius_click', 'description', 'panel | close');
});

$(document).on('click', '.cartGeniusClose', function (e) {
    if (isInWebview()) {
        sendCloseWebviewEventToDeviceCloseOnly();
    }
});

$(document).on('click', '.viewCartGenius', function () {
    if (!window['storeId']) {
        window['isCartGeniusOpened'] = true;
        ServiceTimeslot.openServiceAndTimeslot.bind($('.viewCartGenius'))();
    } else {
        CartGeniusBanner.openCartGeniusDetails();
    }
});

$(window).on('load', function () {
    // After reloading, we automatically open the Cart Genius side panel, but only on pages that do not render the Cart Genius banner
    if (sessionStorage.getItem('triggerOpeningCartGeniusAfterReload') && !$('#cartGeniusContent').length) {
        CartGeniusBanner.openCartGeniusDetails();

        sessionStorage.removeItem('triggerOpeningCartGeniusAfterReload');
    }
});